import styled from "styled-components";

const LoginSignup = styled.div`
  .imageContainer {
    position: relative;
  }
  .bgImage {
    width: 100%;
    height: 100%;
    object-fit: contain;
    position: absolute;

    @media screen and (min-width: 1600px) {
      margin-top: 40px;
    }
  }
  .contentWrapper {
    position: absolute;
    margin-top: 20px;
    width: 100%;
  }
  .icon {
    margin: 0px 10px;
    vertical-align: -5px;
    color: black;
  }
  .backButton {
    color: black;
    padding: 0px;
    font-size: 16px;
  }
  .logoContainer {
    text-align: center;
    position: relative;
    top: 80px;
  }
`;
export default LoginSignup;
